/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.4078 3.8654c-.532-.266-1.1578.1208-1.1578.7155v2.8382c0 .5947.6258.9815 1.1578.7155l2.8382-1.419c.5896-.2949.5896-1.1363 0-1.4311L5.4078 3.8654ZM6.3229 6l-.5729.2865v-.573L6.323 6Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 6c0 3.0443-2.2673 5.5591-5.2054 5.9479C7.0022 12.9759 7.9107 13.75 9 13.75h2.0805C11.4239 12.1774 12.8244 11 14.5 11c1.933 0 3.5 1.567 3.5 3.5S16.433 18 14.5 18c-1.6756 0-3.0761-1.1774-3.4195-2.75H9a3.7338 3.7338 0 0 1-2.25-.7497V17.5c0 1.2426 1.0074 2.25 2.25 2.25h8.0805C17.4239 18.1774 18.8244 17 20.5 17c1.933 0 3.5 1.567 3.5 3.5S22.433 24 20.5 24c-1.6756 0-3.0761-1.1774-3.4195-2.75H9c-2.071 0-3.75-1.6789-3.75-3.75v-5.5464C2.2903 11.5845 0 9.0597 0 6c0-3.3137 2.6863-6 6-6s6 2.6863 6 6Zm-1.5 0c0 2.4853-2.0147 4.5-4.5 4.5S1.5 8.4853 1.5 6 3.5147 1.5 6 1.5s4.5 2.0147 4.5 4.5Zm12 14.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm-8-4c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'GitHubActions'
);
